/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { performCmdbDeleteRequest } from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import { getCmdbConfigStatusTypeByIdUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getCmdbConfigReferenceTypeUrl.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { StatusType, ActionApi } from './ActionApi.types.tsx';

export const deleteStatusType =
	(statusType: StatusType): ActionApi =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		const state = getState();

		setState({
			...state,
			statusTypes: { ...state.statusTypes, deleteLoading: true },
		});

		try {
			await performCmdbDeleteRequest(getCmdbConfigStatusTypeByIdUrl(workspaceId, statusType.id));

			setState({
				...state,
				statusTypes: {
					...state.statusTypes,
					deleteLoading: false,
					data: state.statusTypes.data
						? state.statusTypes.data.filter(({ id }) => id !== statusType.id)
						: undefined,
				},
			});

			fireTrackAnalytics(createAnalyticsEvent({}), 'deleteStatusType succeeded');
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				...state,
				statusTypes: {
					...state.statusTypes,
					deleteLoading: false,
					deleteError: error,
				},
			});

			fireCmdbErrorAnalytics({
				meta: {
					id: 'deleteStatusType',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
					teamName: 'astral',
				},
				error,
			});

			throw error;
		}
	};
